const newsletter = {};

newsletter.generic = () => {
    let $newsletterButtonFooter = document.getElementById("submit-newsletter-footer");
    let $newsletterClosePopup = document.getElementById("close-newsletter-popup");
    let $overlay = document.querySelector('.newsletter-section');
    let $emailFooter = document.getElementById("field_email_footer"),
        $emailPopup = document.getElementById("field_email");

    if ($newsletterButtonFooter) {
        $newsletterButtonFooter.onclick = function () {
            if ($emailFooter.value) {
                $emailPopup.value = $emailFooter.value;
                $emailFooter.classList.remove('with-error');
                $overlay.classList.add('newsletter-section__visible');
                document.body.classList.add('overflow-hidden');
            } else {
                $emailFooter.classList.add('with-error');
            }

        };


    }
    if ($newsletterClosePopup) {
        $newsletterClosePopup.onclick = function () {
            $overlay.classList.remove('newsletter-section__visible');
            document.body.classList.remove('overflow-hidden');
        };
    }


}

newsletter.init = () => {
    newsletter.generic();
}

export default newsletter;
